import { render } from "./ClassHeader.vue?vue&type=template&id=0f11929e&scoped=true"
import script from "./ClassHeader.vue?vue&type=script&lang=js"
export * from "./ClassHeader.vue?vue&type=script&lang=js"

import "./ClassHeader.vue?vue&type=style&index=0&id=0f11929e&scoped=true&lang=css"

import exportComponent from "D:\\Repos\\c2stem\\c2stem-classroom-inquiry\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f11929e"]])

export default __exports__